<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <transition name="fade-transform" mode="out-in">
      <!-- <keep-alive> -->
      <router-view v-if="isRouterAlive"/>
      <!-- </keep-alive> -->
    </transition>
    <!-- <router-view v-if="isRouterAlive" /> -->
  </div>
</template>

<script>
export default {
  // inject: ['reload'],
  name: 'App',
  watch: {
    $route(to, form) {
      // this.reload();
      this.loading();
      // const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
  },
  components: {},
  mounted() {
    // console.log("app");
    // console.log('路径',config.base_url);
    window.addEventListener("message",this.handleJump,false)
  },
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  methods: {
    loading() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中......',
      //   // spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)',
      //   customClass: 'mask'
      // });
      // setTimeout(() => {
      //   loading.close();
      // }, 700);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    },
    handleJump(event) {
      if(event.data.hasOwnProperty("payload") && Object.prototype.toString.call(event.data.payload) === "[object String]") {
        let datas = JSON.parse(event.data.payload)
        if(!this.$store.getters.token || !localStorage.getItem("token")) {
          this.$Token.set(datas.token);
          
          window.parent.postMessage("success","*")
        }
      }
    }
  },
  destroyed() {
    window.removeEventListener("message",this.handleJump)
  }
}
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
  width: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

body {
  min-width: 1300px;
  overflow: hidden;
  padding-right: 0 !important;
}

html::-webkit-scrollbar {
  display: none;
}

body::-webkit-scrollbar {
  display: none;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

/*
enter-active 定义进入过渡的结束状态
leave-active 定义离开过渡的结束状态
 */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

/*
enter定义进入过渡的开始状态
 */
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

/*
leave-to离场动画结束后的状态
 */
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.el-loading-spinner .el-loading-text {
  color: #FFFFFF !important;
  font-size: 16px !important;
}

/* .mask .el-loading-spinner i{color: #FFFFFF !important;font-size: 18px !important;} */
.el-loading-spinner .path {
  stroke: #FFFFFF !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue